import React from 'react';
import HistoryTableHeader from './historyTableHeader';
import { AccountsTableColumnCaptions } from './tableColumnCaptions';

const ProductReleaseHistoryTableHeader = (props) => {
  const { objectData } = props;

  const title = [{
    title: AccountsTableColumnCaptions.login,
    value: objectData ? objectData.login : '',
  }];

  return <HistoryTableHeader captions={AccountsTableColumnCaptions} objectData={objectData} title={title}/>
};

export default ProductReleaseHistoryTableHeader;


// WEBPACK FOOTER //
// ./src/components/accountsHistoryTableHeader.js